import React from 'react'
import {Header} from './Header'
import {Timer} from 'components/timer'

export class ViewerHeader extends React.PureComponent {

  static defaultProps = {
    shareDialogMessage: "Sending a report by email will deliver a link to download a PDF version of your report. The link shared will expire 48h after sending."
  }

  render() {
    const {
      reportFinished, lastSaved, language, dateFormat, studies, readOnly, patientName, fax, sendFaxFetcher,
      reportRecipients, renderEndPoint, loaderEndPoint, userEmail, isUploadingKeyImages, reportUID, sendEmailFetcher,
      hideSavePdfButton, reportInfoCard, sharedReportView, shareDialogMessage, attachedReport, sharingOptions, isPHIPossible
    } = this.props
    return <div className="report-builder-header">
      <Header.LeftContainer
        studies={studies}
        readOnly={readOnly}
        patientName={patientName}
      />
      <div className="right-container">
        <Header.PDFButtons
          hideSavePdfButton={hideSavePdfButton}
          reportRecipients={reportRecipients}
          reportInfoCard={reportInfoCard}
          renderEndPoint={renderEndPoint}
          loaderEndPoint={loaderEndPoint}
          sharedReportView={sharedReportView}
          sharingOptions={sharingOptions}
          userEmail={userEmail}
          fax={fax}
          sendFaxFetcher={sendFaxFetcher}
          isPHIPossible={isPHIPossible}
          reportUID={reportUID}
          sendEmailFetcher={sendEmailFetcher}
          isUploadingKeyImages={isUploadingKeyImages}
          shareDialogMessage={shareDialogMessage}
          attachedReport={attachedReport}
        />
        {
          reportFinished &&
          <span className="last-save-info">
              Last updated: <Timer language={language} dateFormat={dateFormat} time={lastSaved} noPrefix alwaysDate/>
          </span>
        }
        {
          !reportFinished &&
          <span className="last-save-info">
              <b>Report not finished.</b> Draft saved <Timer language={language} dateFormat={dateFormat} time={lastSaved}/>
          </span>
        }
      </div>
    </div>
  }

}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/ViewerHeader.jsx